import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useWarehouseInfo = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get("/saas/order/warehouse-infos");
      setData(data2);
      return {
        warehouseInfoList: data2
      };
    } catch (error) {
      handleError(error);
      return {
        warehouseInfoList: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    warehouseInfoLoading: loading,
    warehouseInfoList: data,
    fetchWarehouseInfoList: fetchData
  };
};
export const useWarehouseInfoModel = createModel(useWarehouseInfo);
export const useWarehouseInfoEnable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get("/saas/warehouseInventories/warehouse/enable", {params});
      setData(data2);
      return {
        warehouseInfoList: data2
      };
    } catch (error) {
      handleError(error);
      return {
        warehouseInfoList: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    warehouseInfoLoading: loading,
    warehouseInfoList: data,
    fetchWarehouseInfoList: fetchData
  };
};
